/**
 * Names the first `maxShown` of `names`, then `othersLabel` for the rest, joined the locale's way:
 * `Hydrofoam, Alginate et 2 autres` in French, `Hydrofoam, Alginate, and 2 others` in English.
 * `othersLabel` receives the count of names left out, and is only called when there are some.
 */
export const formatNameList = (
  names: readonly string[],
  maxShown: number,
  othersLabel: (hiddenCount: number) => string,
  localeCode: string,
): string => {
  const shownNames = names.slice(0, maxShown);
  const hiddenCount = names.length - shownNames.length;
  const items = hiddenCount > 0 ? [...shownNames, othersLabel(hiddenCount)] : shownNames;

  return new Intl.ListFormat(localeCode, { type: 'conjunction' }).format(items);
};
